import { useState } from "react"

import apiCall from "../../helperFunctions/apiCall";
import { givePremium } from "../utilities/auth/authAPI";
import ButtonClose from "../utilities/buttonClose";


function GivePremium(props) {

  // Define variables
  const [active, setActive] = useState(false);
  const [duration, setDuration] = useState(null);
  const [loading, setLoading] = useState(false);
  const inviteInformation = props.inviteInformation;
  const learner = props.learner;
  const learnerId = learner.id;
  let options = [];

  let canGivePremium = false;
  if( learner.subscriptionType === 'Community' ) {
    if( inviteInformation && ( inviteInformation.premiumSeatsAvailable > 0 || inviteInformation.proSeatsAvailable > 0 ) ) {
      if( inviteInformation.options.length > 1 ) {
        canGivePremium = true;
        options = inviteInformation.options.filter(object => object.id !== 'community');
      }
    }
  }


  // Define functions
  function closeModal() {
    setActive(false);
  }

  function handleSubmit() {
    if( !duration ) {
      alert('Select a duration first');
      return;
    }

    setLoading(true);

    const payload = {
      id: learnerId,
      duration: duration
    };

    apiCall(givePremium, payload).then((response) => {
      if( response.success ) {
        alert('Successfully given Premium. Please reload to update the screen.');
        closeModal();
      } else {
        alert(response.error);
      }
    }).finally(() => {
      setTimeout(() => setLoading(false), 400);
    });
  }


  // Screen components
  let bodyElement;
  if( canGivePremium && !active ) {
    bodyElement = <button class='give-premium-button' onClick={() => setActive(true)}>Give Premium</button>;
  }

  if( canGivePremium && active ) {
    bodyElement = (
      <div class='flex-column give-premium-wrapper'>
        <div class='flex-column give-premium-container'>

          <div class='flex-column'>
            <div class='flex-row' style={{width: '100%'}}>
              <span style={{width: '30px'}}>&nbsp;</span>
              <h3>Give Premium</h3>
              <ButtonClose closeAction={closeModal} />
            </div>

            <p style={{marginTop: '30px', marginBottom: '15px'}}>Give {learner.firstName} a Premium account?</p>

            <select
              required
              onChange={event => setDuration(event.target.value)}
            >
              <option value=''>Select</option>
              {options.map((option, index) =>
                <option
                  key={`invite-id-${option.id}`}
                  value={option.id}
                >
                  {option.value}
                </option>
              )}
            </select>
          </div>


          <button
            class={`button primary ${loading ? 'is-loading' : ''}`}
            onClick={() => handleSubmit()}
            disabled={loading}
          >{loading ? '' : 'Submit'}</button>

        </div>
      </div>
    );
  }


  return (
    <>{bodyElement}</>
  );
}

export default GivePremium;